<template>
  <div class="cmi-product-view" v-if="basketCount != 0">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h2>Shopping Basket</h2>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-8">
            <div class="row clearfix-res">
              <transition-group
                name="animate-resource"
                enter-active-class="animated lightSpeedIn"
                leave-active-class="animated zoomOut"
              >
                <div
                  v-for="item in getBasket"
                  v-bind:key="item.pkey"
                  class="col-sm-6"
                >
                  <div class="widget cmi-widget">
                    <div class="sermon-widget">
                      <div class="sermon-img">
                        <img
                          v-bind:src="item.res_FileThumbnailPath"
                          alt="audio cover image"
                        />
                        <span
                          ><i class="fa fa-calendar-o"></i
                          >{{ item.res_MessageLabel }}</span
                        >
                        <h3>
                          <a href="#" title="">{{ item.res_Person }}</a>
                        </h3>
                      </div>
                      <div class="sermon-detail">
                        <p class="sermon-description">
                          <span class="sermon-title">Date: </span
                          ><span class="sermon-text">{{
                            item.res_MessageDate
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Event: </span
                          ><span class="sermon-text">{{ item.res_Event }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Title: </span
                          ><span class="sermon-text">
                            {{ item.res_MessageTitle }}</span
                          >
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Series: </span>
                          <span class="sermon-text">{{
                            item.res_MessageGenre
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Audio file name: </span
                          ><span class="sermon-text">{{
                            item.res_FileName
                          }}</span>
                        </p>
                        <p class="sermon-description">
                          <span class="sermon-title">Item ID: </span
                          ><span class="sermon-text">{{ item.resCode }}</span>
                        </p>
                        <div class="cmi-sermon-purchase">
                          <div class="cmi-price-wrapper">
                            <span class="cmi-price badge">{{
                              item.res_PriceLabel
                            }}</span>
                          </div>
                          <div class="cmi-item-remove">
                            <button
                              @click="removeFromBasketLocal(item)"
                              type="button"
                              class="btn btn-primary btn-lg"
                            >
                              <span class="fa fa-trash-o"></span
                              ><span class="cmi-basket-item-remove-text"
                                >Remove</span
                              >
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </div>
          </div>
          <div class="col-md-4">
            <!--<p class="cmi-basket-info">
                            Please check and be sure that customer's E-mail address is correct. 
                            Audio files dowloading links will sent to this E-mail address.
                        </p>-->
            <admin-order :baseUrl="'Shop/Home/'"></admin-order>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import AdminOrder from "./AdminOrder";
export default {
  components: {
    AdminOrder
  },
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["removeFromBasket"]),
    removeFromBasketLocal: function(item) {
      if (this.$store.state.basket.some(p => p.pkey == item.pkey)) {
        this.removeFromBasket(item);
      }
    }
  },
  computed: {
    ...mapGetters(["basketCount", "getBasket"])
  }
};
</script>
